export function getArticleUrl(article: {
  slug: string;
  publishedAt?: Date | string | null;
  createdAt?: Date | string | null;
}): string {
  const date = article.publishedAt || article.createdAt;
  if (date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `/articles/${year}/${month}/${article.slug}`;
  }
  return `/articles/${article.slug}`;
}
